import SectionHeading from '@/components/feature/SectionHeading';
import { scenes } from '@/mocks/home';

export default function Scenes() {
  return (
    <section id="scenes" className="w-full bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="Key Scenes"
          title="名场面：这些镜头值得反复回看"
          desc="关键镜头往往藏着人物真实的动机，配合集数顺序理解，会看到完全不同的含义。"
        />

        <div className="mt-10 space-y-4 md:space-y-6">
          {scenes.map((s, i) => (
            <article
              key={s.title}
              className={`rounded-lg border border-background-200 bg-background-100 overflow-hidden grid grid-cols-1 md:grid-cols-2 ${
                i % 2 === 1 ? 'md:[&>figure]:order-2' : ''
              }`}
            >
              <figure className="w-full h-56 md:h-72 overflow-hidden">
                <img src={s.image} alt={`${s.title} 名场面剧照`} className="w-full h-full object-cover object-top" />
              </figure>
              <div className="p-5 md:p-8 flex flex-col justify-center">
                <span className="inline-flex w-fit items-center gap-1.5 px-2.5 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-label">
                  <i className="ri-bookmark-3-line" aria-hidden="true" />
                  {s.ep}
                </span>
                <h3 className="mt-3 font-heading text-xl md:text-2xl font-bold text-foreground-950">{s.title}</h3>
                <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{s.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}